import * as React from "react";
import { useTheme } from "styled-components";

import { style, Icon } from "./Symbolicons";

const Share = (props: Icon): React.ReactElement => {
  const theme = useTheme();

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 24 24"
      style={{ ...style(props.size, props.height), ...props.style }}
      className={props.className}
    >
      <g>
        <path
          fill={props.color || theme.palette.grey600}
          fillRule="evenodd"
          d={
            props.variant === "line"
              ? "M18.123 5.345l-.072-.01L18 5.333h-4l-.078.005a.667.667 0 00-.589.662l.005.078c.038.331.32.589.662.589h2.39l-5.528 5.528-.056.063a.667.667 0 00.999.88l5.528-5.529V10l.005.078A.667.667 0 0018.667 10V6l-.005-.078-.023-.111-.02-.059-.016-.036-.032-.06-.057-.08-.058-.062-.058-.048-.075-.05-.112-.048-.088-.023zM8.667 7.334A.667.667 0 008 6.667h-.667l-.117.003a2 2 0 00-1.883 1.997v8l.004.117a2 2 0 001.996 1.883h8l.118-.004a2 2 0 001.882-1.996V16l-.004-.078A.667.667 0 0016 16v.667l-.005.078a.666.666 0 01-.662.588h-8l-.077-.004a.666.666 0 01-.59-.662v-8l.005-.078A.666.666 0 017.333 8H8l.078-.004a.667.667 0 00.589-.663z"
              : "M16.667 15a1.001 1.001 0 012 0v1.467c0 1.213-.988 2.2-2.2 2.2H7.533c-1.213 0-2.2-.987-2.2-2.2V7.534c0-1.214.987-2.2 2.2-2.2H9a1.001 1.001 0 010 2H7.533a.2.2 0 00-.2.2v8.933c0 .11.09.2.2.2h8.934a.2.2 0 00.2-.2V15zm-3.462-8.529a.667.667 0 01.472-1.138h4.99v4.99a.667.667 0 01-1.138.472l-1.22-1.219-3.771 3.771a1.333 1.333 0 11-1.885-1.885l3.771-3.771-1.219-1.22z"
          }
          clipRule="evenodd"
        ></path>
      </g>
    </svg>
  );
};

export { Share };
